import { Group } from 'src/app/management/model/group';
import { ReceiverType } from './receiver-type';
import { Expose } from 'class-transformer';

export class Receiver {
    @Expose()
    name: string;
    @Expose()
    vehId: number;
    @Expose()
    receiverType: ReceiverType;
    @Expose()
    group?: Group;
}
